<template>
  <div class="roadmap-wrapper">
    <h1 class="roadmap-title">
      {{ $t("website.roadmap.roadmap") }}
    </h1>
    <div class="roadmap">
      <div
        v-for="(quarter, index) in roadmap"
        :key="index"
        class="roadmap-section"
      >
        <div class="roadmap-quarter">{{ quarter.title }}</div>
        <div class="roadmap-items">
          <div
            v-for="(item, idx) in quarter.items"
            :key="idx"
            class="roadmap-item"
          >
            <div class="roadmap-item-title">{{ $t(item.title) }}</div>
            <div class="roadmap-item-desc">{{ $t(item.description) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "website",
});

useSeoMeta({
  title: "ChronoFox - Roadmap",
  description: "website.roadmap.Roadmap page",
  keywords: "roadmap, page",
});

const roadmap = ref([
  {
    title: "Q1 2026",
    items: [
      {
        title: "website.roadmap.drive_timlelogs",
        description: "website.roadmap.drive_timelogs_description",
      },
      {
        title: "website.roadmap.improved_team_management",
        description: "website.roadmap.improved_team_management_description",
      },
    ],
  },
  {
    title: "Q2 2026",
    items: [
      {
        title: "website.roadmap.legal_working_hour_tracking",
        description: "website.roadmap.legal_working_hour_tracking_description",
      },
      {
        title: "website.roadmap.overtime_tracking",
        description: "website.roadmap.overtime_tracking_description",
      },
    ],
  },
  {
    title: "Q3 2026",
    items: [
      {
        title: "website.roadmap.vacation_tracking",
        description: "website.roadmap.vacation_tracking_description",
      },
      {
        title: "website.roadmap.sick_leave_tracking",
        description: "website.roadmap.sick_leave_tracking_description",
      },
    ],
  },
]);
</script>

<style scoped>
.roadmap-wrapper {
  background-color: #54433a;
  color: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem;
}

.roadmap-title {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #ff7f00;
}

.roadmap {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 600px;
  width: 100%;
}

.roadmap-section {
  background: #6a4e42;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.roadmap-quarter {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ff7f00;
  margin-bottom: 1rem;
}

.roadmap-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.roadmap-item {
  background: #755e52;
  padding: 1rem;
  border-radius: 8px;
}

.roadmap-item-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #ffaf00;
}

.roadmap-item-desc {
  font-size: 1rem;
  color: #f6f8ff;
}
</style>
